// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { WorkItemModel } from '../../models/work-item';
import { BehaviorSubject } from 'rxjs';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field',
  template: `
  <span *ngIf="workItem$ && fieldSetId && propertyId && property && field" [ngSwitch]="style.current()">
    <e5core-ui-work-field-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' [readonly]='readonly' ></e5core-ui-work-field-box>
    <e5core-ui-work-field-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' [readonly]='readonly' ></e5core-ui-work-field-bootstrap>
    <e5core-ui-work-field-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' [readonly]='readonly' ></e5core-ui-work-field-material>
  </span>
  <div *ngIf="!(workItem$ && fieldSetId && propertyId)" class="e5core-component-error">&lt;e5core-ui-work-field-set&gt; missing [fieldSetId], [propertyId] and [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>`,
})
export class E5coreUiWorkFieldComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() fieldSetId: number ;
  @Input() propertyId: string ;
  @Input() readonly: boolean;

  workItemModel: WorkItemModel ;
  field: UIWorkFieldModel;
  property: UIPropertyModel ;

  constructor(public style:UiStyleService) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-field [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    if (this.fieldSetId === null || this.propertyId === '') {
      console.error('e5core-ui-work-field [propertyId] and [fieldSetId] must have a value');
      return ;
    }

    this.workItem$.subscribe(
      n => {
        this.workItemModel = n ;
        this.field = null ;
        this.property = null ;

        if (!(this.workItemModel && this.workItemModel.fieldsets && this.workItemModel.properties)) {
          return ;
        }
        const fieldset = this.workItemModel.fieldsets.find(fs => fs.fieldSetId == this.fieldSetId) ;
        if(!fieldset) {
          console.warn(`fieldSetId ${this.fieldSetId} not found in workItem$`) ;
          return ;
        }
        const field = fieldset.fields.find(f => f.propertyId == this.propertyId) ;
        if(!field) {
          console.warn(`propertyId ${this.propertyId} from found in workItem$ fields`) ;
          return ;
        }
        const property = this.workItemModel.properties.find(p => p.propertyId == this.propertyId) ;
        if(!property) {
          console.warn(`propertyId ${this.propertyId} from found in workItem$ properties`) ;
          return ;
        }
        this.field = field ;
        this.property = property ;
      }
    );
  }
}
